import { render, staticRenderFns } from "./UserSalesRepresentative.vue?vue&type=template&id=7bd20cd1&"
import script from "./UserSalesRepresentative.vue?vue&type=script&lang=ts&"
export * from "./UserSalesRepresentative.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports